import React from 'react';
import Statistics from './Statistics';

const SectionsContainer = () => {
  return (
    <div>
      <Statistics/>
    </div>
  );
};

export default SectionsContainer;